<template>
    <div
        ref="elSearchbox"
        :data-component="$options.name"
        class="relative screen-m:mb-24"
    >
        <div
            class="absolute -inset-x-16 screen-m:-inset-x-24 inset-y-0 bg-color-signatur-immo-100 screen-l:rounded-10 overflow-hidden"
            data-print-background
        >
            <MsCircle
                v-if="isScreenL"
                class="absolute top-0 left-0"
                data-test-id="circle"
            />
            <MsHouse class="absolute bottom-0 right-0" />
        </div>
        <div class="relative py-32">
            <div class="screen-xxl:max-w-[720px] screen-l:max-w-[606px]">
                <ms-headline
                    type="h1"
                    class="mb-4 screen-m:mb-24"
                    >{{ headline }}
                </ms-headline>
                <div
                    v-if="!isScreenM"
                    class="text-text-l mb-16"
                    data-test-id="resultText"
                >
                    {{ createResultButtonText() }}
                </div>
            </div>
            <div class="flex bg-white rounded-10 screen-xxl:w-[813px] p-8 screen-m:p-16 screen-m:gap-16">
                <template v-if="isScreenM">
                    <ms-filter-property-type
                        :searchFilters="searchFilters"
                        :direction="FlexDirection.ROW"
                    />
                </template>
                <template v-else>
                    <button
                        type="button"
                        class="flex items-center w-full pl-8 rounded-10 bg-color-greyscale-white"
                        data-test-id="filterButton"
                        @click="openFilterModal"
                    >
                        <span class="flex flex-col text-left grow">
                            <span class="text-text-l-mobile">Wonach suchst du?</span>
                            <span class="text-color-greyscale-400 text-text-mobile"
                                >Nutzungsart, Immobilientyp, Ort, …</span
                            >
                        </span>
                    </button></template
                >
                <cs-primary-button
                    class="screen-l:min-w-[218px]"
                    :isLoading="isLoading"
                    :isDisabled="totalCount === 0"
                    isCentered
                    ariaLabel="scrollToList"
                    @click="scrollToTop"
                >
                    <template #icon>
                        <ms-loupe />
                    </template>
                    <template
                        v-if="isScreenL"
                        #default
                        >{{ createResultButtonText() }}</template
                    >
                </cs-primary-button>
            </div>
        </div>
    </div>
</template>
<script lang="ts" src="./MsSearchBox.ts" />
